<template>
  <h1 class="page-title">
    <slot></slot>
  </h1>
</template>

<script>
export default {
  name: "PageTitle"
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 36px;
  line-height: 40px;
  color: var(--v-accent-base);
}
</style>
